<template>
  <div class="row fill-height">
    <div class="col fill-height">
      <p>{{typeName}}</p>
    </div>
  </div>
</template>

<script>
import QuestionType from "root/packages/closeapp/QuestionsManager/assets/types/QuestionType";
export default {
  name: "TypeDisplay",
  props:{
    type:{
      type: Number,
      require:true
    }
  },
  computed:{
    typeName(){
      return QuestionType.toString(this.type);
    }
  }
}
</script>

<style scoped>
</style>
